import { HTTP } from '../../axios/axios'

async function getAll (lang) {
  try {
    const res = await HTTP.get('/blogs', { headers: { 'accept-language': lang } })
    for (const item of res.data) {
      item.categoryId = Array.from(item.categories, i => i._id)
    }
    return res.data
  } catch (error) {
    console.log(error)
  }
}
async function addOne (blogs, lang) {
  blogs.lang = lang
  blogs.createdAt = new Date()
  delete blogs.categories
  return await HTTP.post('/blogs', blogs)
}
async function update (blogs, id) {
  delete blogs.categories
  delete blogs.Year
  return await HTTP.patch('/blogs/' + id, blogs)
}
async function deleteOne (blogs) {
  return await HTTP.delete('/blogs/' + blogs._id)
}
async function deleteMany (arr) {
  return await HTTP.post('/blogs/many', { _id: arr })
}

export default { getAll, deleteMany, addOne, update, deleteOne }
